import Joi from "joi";
import errorsResolver from "../schemeUtils";

const FIELD_LENGTH = 60;

export const wordScheme = Joi.object({
    name: Joi.string()
        .max(200)
        .required()
        .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9\\-. ]{1,200}$'))
        .error(errorsResolver({
            max: `Название должно быть до 200 символов`,
            required: `Название обязательное поле`,
            pattern: `Название содержит некорректные символы`
        }))
});

export const jewelSchemeFunc = (configure) => {
    const NAME_FIELD_LENGTH = configure ? 20 : 60
    const PART_FIELD_LENGTH = configure ? 21 : 60

    return Joi.object({
        name: Joi.string()
            .max(NAME_FIELD_LENGTH)
            .required()
            .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9.\\-,+!{}#( )$%^&*~_:?"/\\\\]*$'))
            .error(errorsResolver({
                max: `Название должно быть до ${NAME_FIELD_LENGTH} символов`,
                required: `Название обязательное поле`,
                pattern: `Название содержит некорректные символы`
            })),

        part: Joi.string()
            .max(PART_FIELD_LENGTH)
            .required()
            .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9.\\-,+!{}#( )$%^&*~_:?"/\\\\]*$'))
            .error(errorsResolver({
                max: `Часть должна быть до ${PART_FIELD_LENGTH} символа`,
                required: `Часть обязательное поле`,
                pattern: `Часть содержит некорректные символы`
            })),
        synonym: Joi.string()
            .max(FIELD_LENGTH).allow('')
            .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9.\\-,+!{}#( )$%^&*~_:?"/\\\\]*$'))
            .error(errorsResolver({
                max: `Синоним должен быть до ${FIELD_LENGTH} символов`,
                pattern: `Синоним содержит некорректные символы`
            }))
    })
}

export const carScheme = Joi.object({
    makeOfCar: Joi.string().trim()
        .max(100)
        .required()
        .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9\\-()/" ]*$'))
        .error(errorsResolver({
            max: `Марка авто должна быть до 100 символов`,
            required: `Марка авто обязательное поле`,
            pattern: `Марка авто содержит некорректные символы`
        })),
    rows: Joi.array().items(Joi.object({
        carModel: Joi.string().trim()
            .max(100)
            .required()
            .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9\\-()/" ]*$'))
            .error(errorsResolver({
                max: `Модель авто должна быть до 100 символов`,
                required: `Модель авто обязательное поле`,
                pattern: `Модель авто содержит некорректные символы`
            }))
    }))
});

export const reasonScheme = Joi.object({
    name: Joi.string()
        .max(200)
        .required()
        .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9.,№:()-/ ]*$'))
        .error(errorsResolver({
            max: `Название должно быть до 200 символов`,
            required: `Название обязательное поле`,
            pattern: `Название содержит некорректные символы`
        })),
    account: Joi.string()
        .max(10)
        .allow('')
        .pattern(new RegExp('^[0-9.]*$'))
        .error(errorsResolver({
            max: `Номер корреспондирующего счета должен быть до 10 символов`,
            required: `Номер к-его счета обязательное поле`,
            pattern: `Номер корреспондирующего счета содержит некорректные символы`
        })),
    code1C: Joi.number()
        .integer()
        .max(999999999)
        .greater(0)
        .unsafe(false)
        .error(errorsResolver({
            numberBase: 'Код 1С обязательное поле',
            numberMax: 'Код 1С должен быть до 10 символов',
            numberUnsafe: 'Код должен быть до 10 символов',
            numberGreater: 'Код должен быть больше 0',
            numberInteger: 'Код 1С должен быть целым числом',
        })),
    credit: Joi.bool()
});
